// extracted by mini-css-extract-plugin
var _1 = "NavigationWrapper_layoutContainer__0MunE";
export { _1 as "layoutContainer" }
